import Deferred from "utils/Deferred";

/**
 * Promise always fired (paywall displayed or not) when Keytar is done processing.
 * @returns {Promise<{ accessAllowed: Boolean, blockoutType: String }>} of done event data
 */
const keytarDone = new Deferred();
export default keytarDone;
